import demo from '@/views/demo';
import register from '@/views/register';
import download from '@/views/download';
import newDetail from '@/views/new-detail';
import studyDetail from '@/views/study-detail';
import videoDetail from '@/views/video-detail';
import nationalDetail from '@/views/national-detail';
import nationalVideoDetail from '@/views/national-video-detail';
import matchDetail from '@/views/match-detail';
import voteDetail from '@/views/vote-detail';
import agreement from '@/views/agreement';
export default [
  {
    path: "/demo",
    name: "demo",
    component: demo
  },
  {
    path: "/register",
    name: "register",
    component: register
  },
  {
    path: "/download",
    name: "download",
    component: download
  },
  {
    path: "/newDetail",
    name: "newDetail",
    component: newDetail
  },
  {
    path: "/studyDetail",
    name: "studyDetail",
    component: studyDetail
  },
  {
    path: "/videoDetail",
    name: "videoDetail",
    component: videoDetail
  },
  {
    path: "/nationalDetail",
    name: "nationalDetail",
    component: nationalDetail
  },
  {
    path: "/nationalVideoDetail",
    name: "nationalVideoDetail",
    component: nationalVideoDetail
  },
  {
    path: "/matchDetail",
    name: "matchDetail",
    component: matchDetail
  },
  {
    path: "/voteDetail",
    name: "voteDetail",
    component: voteDetail
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement
  }
];
